import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import es from "./locales/es.json";
import en from "./locales/en.json";
import va from "./locales/va.json";

i18n.use(initReactI18next).init({
  resources: {
    es: {
      translation: es,
      common: es.common,
      activity: es.activity,
      calendar: es.calendar,
      onboarding: es.onboarding,
      services: es.calendar.serviceAssignmentManager, // Fallback common usage
      workers: es.calendar.schedule,
      settings: es.settings,
      tasks: es.tasks,
      calendar_v2: es.calendar_v2,
      chats: es.chats,
      competitorTable: es.competitorTable,
      sidebar: es.sidebar,
      misAgendas: es.misAgendas,
      supervision: es.supervision,
      tutorialGallery: es.tutorialGallery,
      soporte: es.soporte,
      contacts: es.contacts,
    },
    en: {
      translation: en,
      common: en.common,
      activity: en.activity,
      calendar: en.calendar,
      onboarding: en.onboarding,
      services: en.calendar.serviceAssignmentManager,
      workers: en.calendar.schedule,
      settings: en.settings,
      tasks: en.tasks,
      calendar_v2: en.calendar_v2,
      chats: en.chats,
      competitorTable: en.competitorTable,
      sidebar: en.sidebar,
      misAgendas: en.misAgendas,
      supervision: en.supervision,
      tutorialGallery: en.tutorialGallery,
      soporte: en.soporte,
      contacts: en.contacts,
    },
    va: {
      translation: va,
      common: va.common,
      activity: va.activity,
      calendar: va.calendar,
      onboarding: va.onboarding,
      services: va.calendar.serviceAssignmentManager,
      workers: va.calendar.schedule,
      settings: va.settings,
      tasks: va.tasks,
      calendar_v2: va.calendar_v2,
      chats: va.chats,
      competitorTable: va.competitorTable,
      sidebar: va.sidebar,
      misAgendas: va.misAgendas,
      supervision: va.supervision,
      tutorialGallery: va.tutorialGallery,
      soporte: va.soporte,
      contacts: va.contacts,
    },
  },
  lng: "es",
  fallbackLng: "es",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
